import { render, staticRenderFns } from "./listTabB.vue?vue&type=template&id=87d907f2&scoped=true"
import script from "./listTabB.vue?vue&type=script&lang=js"
export * from "./listTabB.vue?vue&type=script&lang=js"
import style0 from "./listTabB.vue?vue&type=style&index=0&id=87d907f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87d907f2",
  null
  
)

export default component.exports